// wap
function wapGSAPAnimateInit() {
  // kv Begin
      var kvKeyAnimate;
      window.ONE.keyAnimate(
        ".one-kv-img",
        1,
        176,
        15,
        "_png.png",
      ).then(function (re) {
        kvKeyAnimate = re;
        kvKeyAnimate?.from(1);
      });
  // kv End

  // action Begin
  // /*
  $(".one-active-play").click(function () {
    $(".one-video-playDiv").css("display", "flex");
    var src = $(this).attr("data-one-src");
    $(".one-video-playDiv-wrapper").html(
      '<video src="' +
      src +
      '" id="one-video-playDiv-video" class="one-video-playDiv-video" playsinline="true" webkit-playsinline="true" preload="none" controls="controls"></video>'
    );
    $("#one-video-playDiv-video")[0].play();
  });

  // */
  // action End

  // light Begin
  // /*
  ScrollTrigger.create({
    trigger: ".one-light-section",
    start: "40% bottom",
    end: "120% bottom",
    scrub: 1,
    animation: gsap.timeline()
      .fromTo(".one-light-title", { opacity: 1 }, { opacity: 0 })
      .fromTo(".one-light-img", { transform: "scale(2) translateX(2%) translateY(0)" }, { transform: "scale(1) translateX(0%) translateY(10rem)" }, "<")
      .fromTo(".one-light-txt", { transform: "translateY(6rem)", opacity: 0 }, { transform: "translateY(12rem)", opacity: 1, duration: 0.3 })
  });
  // */
  // light End

  // fully Begin
  // /*
  //   ScrollTrigger.create({
  //   trigger: ".one-fully-color",
  //   start: "top top",
  //   end: `+=2000`,
  //   pin: true,
  //   anticipatePin: 1
  // })
  // window.ONE.onePin(".one-fully-section",2000)

  const fullyshowDG = gsap.utils.toArray('.one-fully-section .wap-group-showD');

  // 先创建统一的交错动画（针对所有元素）
  const fullyshowDGAnimation = gsap.from(fullyshowDG, {
    yPercent: 100,
    opacity: 0,
    stagger: 0.1, // 这里才是stagger的正确位置：多个元素之间错开0.1秒
    paused: true // 先暂停动画，由ScrollTrigger控制
  });
  fullyshowDG.forEach((e) => {
    ScrollTrigger.create({
      trigger: e, // 用父容器作为触发点，更合理
      start: "top 90%", // 元素顶部到视口90%位置时开始
      end: "20% 15%", // 结束位置
      animation: fullyshowDGAnimation, // 绑定上面创建的交错动画
      toggleActions: 'play none none reverse', // 滚动到触发点播放，回滚时倒放
      // 可选：添加标记，方便调试
    });
  })

  ScrollTrigger.create({
    trigger: ".one-fully-media",
    start: "30% bottom",
    end: `60% bottom`,
    scrub: 1,
    animation: gsap.timeline()
      .fromTo([".one-fully-img2", ".one-fully-img3"], { marginTop: "0rem" }, { marginTop: "-3rem" }, "<")
      .fromTo(".one-fully-img2", { opacity: 1 }, { opacity: 0, duration: 0.1 }, "<")
      .fromTo(".one-fully-img3", { opacity: 0 }, { opacity: 1, duration: 0.1 }, "<")
  });

  ScrollTrigger.create({
    trigger: ".one-fully-media",
    start: "60% bottom",
    end: `100% bottom`,
    scrub: 1,
    animation: gsap.timeline()
      .fromTo(".one-fully-shadow", { opacity: 0 }, { opacity: 1 })
      .fromTo(".one-fully-card1", { yPercent: 50, opacity: 0 }, { yPercent: 0, opacity: 1 }, "<+0.2s")
      .fromTo(".one-fully-card2", { yPercent: 50, opacity: 0 }, { yPercent: 0, opacity: 1 }, "<+0.2s")
      .fromTo(".one-fully-card3", { yPercent: 50, opacity: 0 }, { yPercent: 0, opacity: 1 }, "<+0.2s")
    // .fromTo(".one-fully-cardbox", {  opacity: 0,bottom: "0", y: "6rem" }, {  opacity: 1 ,bottom: "3rem", y: 0,duration: 0.3}, "<")
  });
  // */
  // fully End

  // featherlight Begin
  new Swiper(".one-featherlight-box", {
    wrapperClass: "one-featherlight-div",
    slideClass: "one-featherlight-card",
    watchSlidesProgress: true,
    touchMoveStopPropagation: true,
    autoplay: {
      delay: 3000, // 设置轮播的延迟时间
      disableOnInteraction: true,
    },
    on: {
      slideChangeTransitionStart: function () {

      },
    },
    navigation: {
      prevEl: '.one-featherlight-btn.one-btn-left',
      nextEl: '.one-featherlight-btn.one-btn-right',
      disabledClass: 'one-featherlight-btn-disabled'

    },
  });
  // featherlight End






  // color Begin
  var colorKeyAnimate, colorTimer;
  window.ONE.keyAnimate(
    ".one-color-video",
    1,
    90,
    18,
    ".png.webp",
  ).then(function (re) {
    colorKeyAnimate = re;
  });

  ScrollTrigger.create({
    trigger: ".one-color-section",
    start: `top top`,
    scrub: true,
    // markers: true ,
    animation: gsap.timeline().to(".one-color-section", {
      onStart: function () {
        colorKeyAnimate?.from(1);
        colorTimer = setTimeout(function () {
          clearTimeout(colorTimer);
        }, 1660)
      }
    })
  });
  // color End


  // ai Begin
  new Swiper(".one-ai-swiper", {
    slidesPerView: 'auto', // 自动根据滑块宽度计算显示数量（推荐）
    watchSlidesProgress: true,
    touchMoveStopPropagation: true,
    autoplay: {
      delay: 3000, // 设置轮播的延迟时间
      disableOnInteraction: true,
    },
    on: {
      slideChangeTransitionStart: function () {

      },
    },
    navigation: {
      prevEl: '.one-ai-btn.one-btn-left',
      nextEl: '.one-ai-btn.one-btn-right',
      disabledClass: 'one-ai-btn-disabled'

    },
  });
  // ai End

  // camera Begin
  // /*
  ScrollTrigger.create({
      trigger: ".one-camera-section",
      start: "top 80%",
    // markers:true,
      animation: gsap.from('.one-camera-title', {
        yPercent: 50,
        opacity: 0,
        stagger: 0.1,
        duration: 1.5
      }),
      toggleActions: 'play none none reverse'
    });
  const cameraanimation = gsap.timeline({ paused: true })
    .fromTo(".one-camera-img", { transform: 'scale(1.1) translateY(3rem)  translateX(1rem)' }, { transform: 'scale(1) translateY(0) translateX(0)' })
  ScrollTrigger.create({
    trigger: ".one-camera-section",
    start: "top 70%",
    // scrub: true,
    // markers:true,
    animation: cameraanimation,
    toggleActions: 'play none none reverse'
  });
  // */
  // camera End

  // capture begin
  var captureKeyAnimate, captureTimer;
  window.ONE.keyAnimate(
    ".one-capture-video",
    1,
    88,
    18,
    ".png.webp",
  ).then(function (re) {
    captureKeyAnimate = re;
  });

  ScrollTrigger.create({
    trigger: ".one-capture-video",
    start: "top 60%",
    end: "top 20%",
    scrub: true,
    animation: gsap.timeline()
      .fromTo(".one-capture-video", { borderRadius: '0.8rem', width: '16.4rem', height: '10.5rem' }, { borderRadius: '0rem', width: '18rem', height: '12.1rem' })
      .to(".one-capture-video", {
        onStart: function () {
          captureKeyAnimate?.from(1);
          captureTimer = setTimeout(function () {
            clearTimeout(captureTimer);
          }, 1660)
        },
        onReverseComplete: function () {
          clearTimeout(captureTimer);
          captureKeyAnimate.stop();
        }
      }, '<')
  });
  // capture end


  // best Begin
  new Swiper(".one-best-swiper", {
    slidesPerView: 'auto', // 自动根据滑块宽度计算显示数量（推荐）
    watchSlidesProgress: true,
    touchMoveStopPropagation: true,
    autoplay: {
      delay: 2000, // 设置轮播的延迟时间
      disableOnInteraction: true,
    },
    on: {
      slideChangeTransitionStart: function () {

      },
    },
    navigation: {
      prevEl: '.one-best-btn.one-btn-left',
      nextEl: '.one-best-btn.one-btn-right',
      disabledClass: 'one-best-btn-disabled'

    },
  });
  // best End

  // control Begin
  new Swiper(".one-control-swiper", {
    slidesPerView: 'auto', // 自动根据滑块宽度计算显示数量（推荐）
    watchSlidesProgress: true,
    touchMoveStopPropagation: true,
    autoplay: {
      delay: 1500, // 设置轮播的延迟时间
      disableOnInteraction: true,
    },
    on: {
      slideChangeTransitionStart: function () {

      },
      slideChange: function () {
        console.log(this.activeIndex);
        $('.one-control-itemBox .one-control-item').removeClass('active')
        $('.one-control-itemBox .one-control-item').eq(this.activeIndex).addClass('active')
      }
    },
    navigation: {
      prevEl: '.one-control-btn.one-btn-left',
      nextEl: '.one-control-btn.one-btn-right',
      disabledClass: 'one-control-btn-disabled'

    },
  });
  // control End

  // media Begin
  new Swiper(".one-media-swiper", {
    slidesPerView: 'auto', // 自动根据滑块宽度计算显示数量（推荐）
    watchSlidesProgress: true,
    touchMoveStopPropagation: true,
    autoplay: {
      delay: 3000, // 设置轮播的延迟时间
      disableOnInteraction: true,
    },
    on: {
      slideChangeTransitionStart: function () {

      },
    },
    navigation: {
      prevEl: '.one-media-btn.one-btn-left',
      nextEl: '.one-media-btn.one-btn-right',
      disabledClass: 'one-media-btn-disabled'

    },
  });
  // media End

  // style Begin
  // /*
  const styleanimation = gsap.timeline({ paused: true }).
    fromTo(".one-style-title ", { opacity: 0, yPercent: 50 }, { opacity: 1, yPercent: 0 })
    .fromTo(".one-style-item1", { opacity: 0, yPercent: 50 }, { opacity: 1, yPercent: 0 }, "<0.2s")
    .fromTo(".one-style-item2 ", { opacity: 0, yPercent: 50 }, { opacity: 1, yPercent: 0 }, "<0.2s")
  ScrollTrigger.create({
    trigger: ".one-style-section",
    start: "top 60%",
    // scrub: true,
    // markers:true,
    animation: styleanimation,
    toggleActions: 'play none none reverse'
  });

  // */
  // style End

  // detail Begin
  // /*


  const detailSection = document.querySelector('.one-detail-section');
  const detailshowD = gsap.utils.toArray('.one-detail-section .pc-showD');

  if (detailSection && detailshowD.length > 0) {
    ScrollTrigger.create({
      trigger: detailSection,
      start: "top 20%",
      end: "20% 15%",
      animation: gsap.from(detailshowD, {
        yPercent: 200,
        opacity: 0,
        stagger: 0.1,
        duration: 1
      }),
      toggleActions: 'play none none reverse'
    });
  }
  // */
  // detail End

  // users Begin
  new Swiper(".one-users-swiper", {
    slidesPerView: 'auto', // 自动根据滑块宽度计算显示数量（推荐）
    watchSlidesProgress: true,
    touchMoveStopPropagation: true,
    autoplay: {
      delay: 3000, // 设置轮播的延迟时间
      disableOnInteraction: true,
    },
    on: {
      slideChangeTransitionStart: function () {

      },
    },
    navigation: {
      prevEl: '.one-users-btn.one-btn-left',
      nextEl: '.one-users-btn.one-btn-right',
      disabledClass: 'one-users-btn-disabled'

    },
  });
  // users End


  const showD = gsap.utils.toArray('.wap-showD');
  showD.forEach(function (e, t) {
    ScrollTrigger.create({
      trigger: e,
      start: "top 90%",
      end: "20% 15%",
      animation: gsap.from(e, {
        yPercent: 20,
        opacity: 0,
        stagger: 0.1,
        duration: 1
      }),
      toggleActions: 'play none none reverse'
    });
  })

  const showDG = gsap.utils.toArray('.wap-groups-showD .wap-group-showD');

  // 先创建统一的交错动画（针对所有元素）
  const showDGAnimation = gsap.from(showDG, {
    yPercent: 50,
    opacity: 0,
    stagger: 0.1, // 这里才是stagger的正确位置：多个元素之间错开0.1秒
    paused: true // 先暂停动画，由ScrollTrigger控制
  });
  showDG.forEach((e) => {
    // 为整个元素组创建一个ScrollTrigger（而不是每个元素单独创建）
    ScrollTrigger.create({
      trigger: e, // 用父容器作为触发点，更合理
      start: "top 90%", // 元素顶部到视口90%位置时开始
      end: "20% 15%", // 结束位置
      animation: showDGAnimation, // 绑定上面创建的交错动画
      toggleActions: 'play none none reverse', // 滚动到触发点播放，回滚时倒放
      // 可选：添加标记，方便调试
      // markers: true 
    });
  })

}
